"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const defaultGetTokenEditableValue = (tokenValue, tokenMeta) => {
    return `${tokenValue}`;
};
exports.default = defaultGetTokenEditableValue;
